import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ArrowUp } from "react-bootstrap-icons";

const ScrollTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Check if the user has scrolled more than 30% of the page
      if (scrollPosition + windowHeight > documentHeight * 0.3) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check to set the correct button visibility

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: show ? "block" : "none",
        backgroundColor: "#000",
        borderColor: "#000"
      }}
      variant="primary"
      className="d-flex align-items-center justify-content-center"
    >
      <ArrowUp />
    </Button>
  );
};

export default ScrollTop;
